module.exports = __webpack_public_path__ + "static/iPhone-X-a5efc64ed032a701d7205e8b4ddc5da8.png";